import module from 'contabilidad/polizasexternas/module'
import template from './template.html'

export class contabilidadPolizasexternasAlgodonerosIngresosListaVinculacionSeleccionar {
  maximo = 0;
  importe

  $onInit() {
    this.importe = this.movimiento.importe > this.item.saldo ? this.item.saldo : this.movimiento.importe
    this.maximo = this.importe
  }

  cancelar() {
    this.onClose()
  }

  finalizar() {
    this.onClose({ $event: this.importe })
  }
}

module.component('contabilidadPolizasexternasAlgodonerosIngresosListaVinculacionSeleccionar', {
  controller: contabilidadPolizasexternasAlgodonerosIngresosListaVinculacionSeleccionar,
  template,
  bindings: {
    item: '<',
    movimiento: '<',
    onClose: '&',
  },
})




// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/components/algodoneros/ingresos/lista/vinculacion/seleccionar/component.js